module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAQMAAAC19SzWAAAABlBMVEWGFiP///8wFwrqAAAAGUlEQVQ4y2MYBaOAFPAfCTwY0bxRMApIAAAF0PO9aP8rCgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Latvia.png
// module id = 586
// module chunks = 0